import {ref} from 'vue';

export default {
    install: (app, options) => {
        const brands = ref([]);

        const loadBrands = (id) => {
            window.lazy_axios.get(`/brands/?type_id=${id}`)
                .then((response) => {
                    if (response.data.brands) {
                        brands.value = response.data.brands;
                    }
                });
        };

        app.provide('brands', brands);
        app.provide('loadBrands', loadBrands);
    },
}
